function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import { BreakpointWatcherContext } from "../../context";
import React, { Component, Fragment } from 'react';
import { Loader } from '..';
import { getValueForBreakpoint } from "../../utils";
import * as comparators from "./comparators";
import { ListPlaceholder } from "./List.styles";
import { Table } from "./table/Table";
export var List =
/*#__PURE__*/
function (_Component) {
  _inherits(List, _Component);

  function List(props) {
    var _this;

    _classCallCheck(this, List);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(List).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "timeout", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "loaderRef", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleTimeout", function () {
      if (!_this.props.onLoadMore || _this.props.loading || _this.props.endReached || !_this.loaderRef.current) return;

      var _this$loaderRef$curre = _this.loaderRef.current.getBoundingClientRect(),
          top = _this$loaderRef$curre.top,
          height = _this$loaderRef$curre.height;

      if (top + _this.props.loaderTreshold * height < document.body.offsetHeight) {
        _this.props.onLoadMore();
      }
    });

    _this.loaderRef = React.createRef();
    return _this;
  }

  _createClass(List, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.timeout = window.setInterval(this.handleTimeout, this.props.loaderPollingRate);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.loaderPollingRate !== this.props.loaderPollingRate) {
        window.clearInterval(this.timeout);
        this.timeout = window.setInterval(this.handleTimeout, this.props.loaderPollingRate);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.clearInterval(this.timeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          data = _this$props.data,
          defaultSorting = _this$props.defaultSorting,
          detailsComponent = _this$props.detailsComponent,
          endReached = _this$props.endReached,
          grouping = _this$props.grouping,
          placeholder = _this$props.placeholder,
          showTableHeader = _this$props.showTableHeader,
          columns = _this$props.columns,
          onLoadMore = _this$props.onLoadMore,
          loading = _this$props.loading,
          loadingNextPage = _this$props.loadingNextPage;
      var table = loading && !loadingNextPage ? null : data.length === 0 && placeholder ? React.createElement(Fragment, null, React.createElement(ListPlaceholder, null, placeholder)) : React.createElement(BreakpointWatcherContext.Consumer, null, function (_ref) {
        var index = _ref.index;
        return React.createElement(Table, {
          ref: _this2.props.tableRef,
          columns: getValueForBreakpoint(index, columns),
          data: data,
          defaultSorting: defaultSorting,
          detailsComponent: detailsComponent && getValueForBreakpoint(index, detailsComponent),
          grouping: grouping && getValueForBreakpoint(index, grouping),
          showHeader: showTableHeader && getValueForBreakpoint(index, showTableHeader)
        });
      });
      var loader = loading || onLoadMore && !endReached ? React.createElement(Loader, {
        key: "loader",
        style: {
          margin: '1.5rem 0 0'
        },
        innerRef: this.loaderRef
      }) : null;
      return React.createElement(Fragment, null, table, React.createElement("div", {
        className: "table__loader ".concat(loading ? 'table__loader--active' : 'table__loader--inactive', " ")
      }, loader));
    }
  }]);

  return List;
}(Component);

_defineProperty(List, "comparators", comparators);

_defineProperty(List, "defaultProps", {
  loaderPollingRate: 300,
  loaderTreshold: 0.1
});